import { ProductCatalogAttributeSelectionType } from '@graphql/generated';
import { CatalogProductListFilters } from '../Catalog.types';

export const filterSupportedAttributeList = (filters: CatalogProductListFilters) => {
  return filters.filter(filter => {
    const { filterSelectionType } = filter.attributeGroup;
    return (
      filterSelectionType === ProductCatalogAttributeSelectionType.stringListMulti ||
      filterSelectionType === ProductCatalogAttributeSelectionType.priceRange ||
      filterSelectionType === ProductCatalogAttributeSelectionType.priceBucket
    );
  });
};
